import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/tag.scss';
//# sourceMappingURL=index.mjs.map
